__turbopack_context__.v({
  "component": "style-module-scss-module__RryCYW__component",
  "component-regular": "style-module-scss-module__RryCYW__component-regular",
  "component-small": "style-module-scss-module__RryCYW__component-small",
  "cta-button": "style-module-scss-module__RryCYW__cta-button",
  "disclaimer": "style-module-scss-module__RryCYW__disclaimer",
});
